<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex items-center justify-center px-4"
    >
      <!-- Backdrop - no click-to-dismiss: an organisation has to be chosen
           before any panel request can name the one it acts on. -->
      <div class="absolute inset-0 backdrop-blur-sm bg-black/40"></div>

      <div
        class="relative z-20 bg-white rounded-2xl shadow-2xl border border-gray-200/80 px-8 py-8 max-w-lg w-full"
      >
        <div class="flex items-center gap-2.5 mb-6">
          <div
            class="w-9 h-9 rounded-xl bg-gradient-to-br from-[#4A8EEE] to-[#1E3456] flex items-center justify-center shrink-0"
          >
            <Building2 class="w-4.5 h-4.5 text-white" />
          </div>
          <div>
            <h3 class="text-lg font-bold text-[#1E3456] leading-tight">
              Select Organisation
            </h3>
            <p class="text-xs font-medium text-[#6B7280]">
              You belong to {{ organisations.length }} organisations - choose
              the one to continue with
            </p>
          </div>
        </div>

        <div class="space-y-3 max-h-[60vh] overflow-y-auto">
          <button
            v-for="org in organisations"
            :key="org.uuid"
            class="w-full text-left border border-gray-200 rounded-xl p-4 bg-white shadow-sm hover:shadow-md hover:border-[#4A8EEE]/40 transition-all duration-200 group flex items-center gap-3 cursor-pointer"
            @click="select(org.uuid)"
          >
            <div
              class="w-10 h-10 rounded-xl bg-[#E0EDFF] text-[#2563EB] flex items-center justify-center shrink-0 font-bold text-sm"
            >
              {{ initials(org.name) }}
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-bold text-[#1E3456] truncate">
                {{ org.name }}
              </p>
              <p class="text-xs font-medium text-gray-500 truncate">
                <span v-if="org.code">{{ org.code }}</span>
                <span v-if="org.code && org.role"> · </span>
                <span v-if="org.role" class="capitalize">{{
                  org.role.toLowerCase()
                }}</span>
              </p>
            </div>
            <ArrowRight
              class="w-4 h-4 text-gray-300 group-hover:text-[#4A8EEE] transition-colors shrink-0"
            />
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { Building2, ArrowRight } from 'lucide-vue-next';

defineProps({
  isOpen: Boolean,
});

const emit = defineEmits(['selected']);

const authStore = useAuthOrganisationStore();
const { organisations } = storeToRefs(authStore);

const initials = (name) =>
  (name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

const select = (uuid) => {
  // Persisted through the store's existing mechanism, so every subsequent
  // request picks it up as `X-Organisation-Id`.
  authStore.selectOrganisation(uuid);
  emit('selected', uuid);
};
</script>
